// import { useEffect, useState } from "react";
// import NavbarComp from "../components/navbar";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { CircularProgress } from '@mui/material';

// const Directory = () => {
//     const location = useLocation();
//     const [data, setData] = useState([]);
//     const [search, setSearch] = useState("");
//     const [activeCategory, setActiveCategory] = useState("All Directory");
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
//     const backendURL = process.env.REACT_APP_BACKEND_URL;
//     const [isLoading, setIsLoading] = useState(false);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setIsLoading(true);
//                 let response;
//                 if (activeCategory === "All Directory") {
//                     response = await axios.get(`${backendURL}/api/directory`);
//                 } else {
//                     const categoryMap = {
//                         "Business": "business",
//                         "Church Lodges": "church_lodges",
//                         "Natural Healers": "natural_healers",
//                     };
//                     const categoryParam = categoryMap[activeCategory];
//                     response = await axios.get(`${backendURL}/api/directory/type/${categoryParam}`);
//                 }

//                 const directoryArray = Array.isArray(response.data)
//                     ? response.data
//                     : response.data.data;

//                 setData(directoryArray || []);
//                 setIsLoading(false);
//             } catch (error) {
//                 console.error("Error fetching directory data:", error);
//                 setData([]);
//                 setIsLoading(false);
//             }
//         };

//         fetchData();
//     }, [activeCategory, backendURL]);

//     const filteredData = data.filter((item) => {
//         const itemLocation = (item.location || "").toLowerCase();
//         const keywordsString = Array.isArray(item.keywords)
//             ? item.keywords.join(" ").toLowerCase()
//             : (item.keywords || "").toLowerCase();

//         const itemData = `${itemLocation} ${keywordsString}`;
//         const searchWords = search.toLowerCase().split(/\s+/).filter(Boolean);
//         const matchesSearch =
//             searchWords.length === 0 ||
//             searchWords.every((word) => itemData.includes(word));

//         return matchesSearch;
//     });

//     const sortedData = [...filteredData].sort((a, b) => {
//         if (!sortConfig.key) return 0;
//         const valA = (a[sortConfig.key] || "").toLowerCase();
//         const valB = (b[sortConfig.key] || "").toLowerCase();

//         if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
//         if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//     });

//     const handleSort = (key, direction) => {
//         setSortConfig({ key, direction });
//     };

//     if (isLoading) {
//         return (
//             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
//                 <CircularProgress />
//             </div>
//         );
//     }

//     return (
//         <div className="bg-gray-100 min-h-screen">
//             {location.pathname === "/directory" && <NavbarComp />}

//             <div className="max-w-[1600px] mx-auto px-4 py-8">
//                 {/* <div className="mb-12 flex items-center gap-4">
//                     <label htmlFor="search" className="text-3xl font-bold text-gray-800 whitespace-nowrap">
//                         Search:
//                     </label>
//                     <input
//                         type="text"
//                         id="search"
//                         placeholder="Location or Keywords..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                         className="w-8/12 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     />
//                 </div> */}

//                 <div className="bg-gray-100 flex flex-col justify-center items-center mb-4">
//                     <div className="w-[90%] px-2 py-2 rounded-lg">
//                         {/* <p className="text-2xl font-bold mb-6">Back Office Educational Portal</p> */}
//                         <p className="text-gray-700 mb-2 text-xl">
//                             Welcome to the Church’s Directory of approved <strong>Businesses</strong>, <strong>Church Lodges</strong>, and <strong>Natural Healers</strong>.
//                             We encourage you to support their efforts and services. If you are a business, lodge, or natural healer interested in being included in this directory, please get in touch with us with your information for consideration.
//                         </p>
//                     </div>
//                 </div>


//                 {/* Search Section */}
//                 <div className="mb-12 flex flex-col md:flex-row md:items-center gap-4 ml-16">
//                     <label htmlFor="search" className="text-2xl md:text-3xl font-bold text-gray-800 whitespace-nowrap">
//                         Search:
//                     </label>
//                     <input
//                         type="text"
//                         id="search"
//                         placeholder="Location or Keywords..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                         className="w-full md:w-8/12 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     />
//                 </div>

//                 <div className="flex flex-wrap gap-4 mb-8 justify-center">
//                     {["All Directory", "Business", "Church Lodges", "Natural Healers"].map((category) => (
//                         <button
//                             key={category}
//                             onClick={() => setActiveCategory(category)}
//                             className={`px-4 py-2 rounded-full font-semibold transition-colors ${activeCategory === category
//                                 ? "bg-blue-600 text-white shadow-lg"
//                                 : "bg-blue-100 text-blue-800 hover:bg-blue-200"
//                                 }`}
//                         >
//                             {category}
//                         </button>
//                     ))}
//                 </div>

//                 <div className="mt-10 bg-white rounded-lg shadow-md w-full">
//                     <table className="w-full divide-y divide-gray-200 text-center table-fixed">
//                         <thead className="bg-gradient-to-r from-blue-500 to-purple-500 text-white">
//                             <tr className="divide-x divide-white">
//                                 {/* Name Header with Dropdown */}
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-left relative group">
//                                     <div className="flex items-center justify-between">
//                                         <span>Name</span>
//                                         <div className="relative">
//                                             <button className="ml-1">
//                                                 <span className="text-white">▼</span>
//                                             </button>
//                                             {/* Dropdown on hover */}
//                                             <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40 animate-fade-in">
//                                                 <div
//                                                     onClick={() => handleSort("name", "asc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
//                                                 >
//                                                     Sort A → Z
//                                                 </div>
//                                                 <div
//                                                     onClick={() => handleSort("name", "desc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
//                                                 >
//                                                     Sort Z → A
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </th>

//                                 {/* Location Header */}
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-left relative group">
//                                     <div className="flex items-center justify-between">
//                                         <span>Location</span>
//                                         <div className="relative">
//                                             <button className="ml-1">
//                                                 <span className="text-white">▼</span>
//                                             </button>
//                                             {/* Dropdown on hover */}
//                                             <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40 animate-fade-in">
//                                                 <div
//                                                     onClick={() => handleSort("location", "asc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-t-md transition-all"
//                                                 >
//                                                     Sort A → Z
//                                                 </div>
//                                                 <div
//                                                     onClick={() => handleSort("location", "desc")}
//                                                     className="px-4 py-2 hover:bg-blue-100 cursor-pointer rounded-b-md transition-all"
//                                                 >
//                                                     Sort Z → A
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </th>

//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider w-1/3">Information</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Keywords</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Email</th>
//                                 <th className="px-4 py-3 text-xs font-medium uppercase tracking-wider">Website</th>
//                             </tr>
//                         </thead>
//                         <tbody className="divide-y divide-gray-200">
//                             {sortedData.length > 0 ? (
//                                 sortedData.map((item, index) => (
//                                     <tr key={index} className="hover:bg-gray-50 transition divide-x divide-gray-200 text-gray-800">
//                                         <td className="px-4 py-3 break-words w-[220px]">{item.name || "N/A"}</td>
//                                         <td className="px-4 py-3 whitespace-nowrap">{item.location || "N/A"}</td>
//                                         <td className="px-4 py-3 text-left max-w-[400px] break-words text-sm">{item.info || "N/A"}</td>
//                                         <td className="px-4 py-3 text-left break-words">
//                                             {Array.isArray(item.keywords)
//                                                 ? item.keywords.join(", ")
//                                                 : (item.keywords || "N/A")}
//                                         </td>
//                                         <td className="px-4 py-3 break-words w-[220px] text-sm">
//                                             {item.email && item.email !== "N/A" ? (
//                                                 <a
//                                                     href={`mailto:${item.email}`}
//                                                     className="text-blue-600 hover:underline break-all block"
//                                                 >
//                                                     {item.email}
//                                                 </a>
//                                             ) : "N/A"}
//                                         </td>
//                                         <td className="px-4 py-3">
//                                             {item.website && item.website !== "N/A" ? (
//                                                 <a href={item.website.startsWith("http") ? item.website : `https://${item.website}`} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">{item.website}</a>
//                                             ) : "N/A"}
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="6" className="text-center py-6 text-gray-500 italic">No data found.</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Directory;



import { useEffect, useState } from "react";
import NavbarComp from "../components/navbar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from '@mui/material';
import Loader from "components/Loader";

const Directory = () => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [activeCategory, setActiveCategory] = useState("All Directory");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // const fetchData = async () => {
        //     try {
        //         setIsLoading(true);
        //         let response;
        //         if (activeCategory === "All Directory") {
        //             response = await axios.get(`${backendURL}/api/directory`);
        //         } else {
        //             const categoryMap = {
        //                 "Business": "business",
        //                 "Church Lodges": "church_lodges",
        //                 "Natural Healers": "natural_healers",
        //             };
        //             const categoryParam = categoryMap[activeCategory];
        //             response = await axios.get(`${backendURL}/api/directory/type/${categoryParam}`);
        //         }

        //         const directoryArray = Array.isArray(response.data)
        //             ? response.data
        //             : response.data.data;

        //         setData(directoryArray || []);
        //         setIsLoading(false);
        //     } catch (error) {
        //         console.error("Error fetching directory data:", error);
        //         setData([]);
        //         setIsLoading(false);
        //     }
        // };

        const fetchData = async () => {
            try {
                setIsLoading(true);
                let response;
                if (activeCategory === "All Directory") {
                    response = await axios.get(`${backendURL}/api/directory`);
                } else {
                    const categoryMap = {
                        Business: "business",
                        "Church Lodges": "church_lodges",
                        "Natural Healers": "natural_healers",
                    };
                    const categoryParam = categoryMap[activeCategory];
                    response = await axios.get(
                        `${backendURL}/api/directory/type/${categoryParam}`
                    );
                }

                // Ensure response data is an array and sorted by order
                let directoryArray = Array.isArray(response.data)
                    ? response.data
                    : response.data.data;

                if (directoryArray && directoryArray.length) {
                    directoryArray.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
                }

                setData(directoryArray || []);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching directory data:", error);
                setData([]);
                setIsLoading(false);
            }
        };
        fetchData();
    }, [activeCategory, backendURL]);

    const filteredData = data.filter((item) => {
        const itemLocation = (item.location || "").toLowerCase();
        const keywordsString = Array.isArray(item.keywords)
            ? item.keywords.join(" ").toLowerCase()
            : (item.keywords || "").toLowerCase();

        const itemData = `${itemLocation} ${keywordsString}`;
        const searchWords = search.toLowerCase().split(/\s+/).filter(Boolean);
        const matchesSearch =
            searchWords.length === 0 ||
            searchWords.every((word) => itemData.includes(word));

        return matchesSearch;
    });

    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = (a[sortConfig.key] || "").toLowerCase();
        const valB = (b[sortConfig.key] || "").toLowerCase();

        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const handleSort = (key, direction) => {
        setSortConfig({ key, direction });
    };

    if (isLoading) {
        return (
            <Loader />
        );
    }

    return (
        <div className="bg-gray-100 min-h-screen">
            {location.pathname === "/directory" && <NavbarComp />}

            <div className="max-w-[1600px] mx-auto px-4 py-8">
                {/* Welcome Text */}
                <div className="bg-gray-100 flex flex-col justify-center items-center mb-4">
                    <div className="w-[90%] px-2 py-2 rounded-lg">
                        <p className="text-gray-700 mb-2 text-xl text-center">
                            Welcome to the Church’s Directory of approved <strong>Businesses</strong>, <strong>Church Lodges</strong>, and <strong>Natural Healers</strong>.
                            We encourage you to support their efforts and services. If you are a business, lodge, or natural healer interested in being included in this directory,
                            please get in touch with us with your information for consideration.
                        </p>
                    </div>
                </div>

                {/* Search Section */}
                <div className="mb-12 flex flex-col md:flex-row md:items-center gap-4 ml-4 md:ml-16">
                    <label htmlFor="search" className="text-2xl md:text-3xl font-bold text-gray-800 whitespace-nowrap">
                        Search:
                    </label>
                    <input
                        type="text"
                        id="search"
                        placeholder="Location or Keywords..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full md:w-8/12 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                </div>

                {/* Category Filter Buttons */}
                <div className="flex flex-wrap gap-4 mb-8 justify-center">
                    {["All Directory", "Business", "Church Lodges", "Natural Healers"].map((category) => (
                        <button
                            key={category}
                            onClick={() => setActiveCategory(category)}
                            className={`px-4 py-2 rounded-full font-semibold transition-colors ${activeCategory === category
                                ? "bg-blue-600 text-white shadow-lg"
                                : "bg-blue-100 text-blue-800 hover:bg-blue-200"
                                }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Directory Table */}
                <div className="mt-10 bg-white rounded-lg shadow-md w-full overflow-x-auto">
                    <table className="min-w-[800px] w-full divide-y divide-gray-200 text-center">
                        <thead className="bg-gradient-to-r from-blue-500 to-purple-500 text-white">
                            <tr className="divide-x divide-white text-sm">
                                {/* Name Header */}
                                <th className="px-4 py-3 text-left whitespace-nowrap min-w-[150px] relative group">
                                    <div className="flex items-center justify-between">
                                        <span>Name</span>
                                        <div className="relative">
                                            <button className="ml-1"><span>▼</span></button>
                                            <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40">
                                                <div onClick={() => handleSort("name", "asc")} className="px-4 py-2 hover:bg-blue-100 cursor-pointer">Sort A → Z</div>
                                                <div onClick={() => handleSort("name", "desc")} className="px-4 py-2 hover:bg-blue-100 cursor-pointer">Sort Z → A</div>
                                            </div>
                                        </div>
                                    </div>
                                </th>

                                {/* Location Header */}
                                <th className="px-4 py-3 text-left whitespace-nowrap min-w-[150px] relative group">
                                    <div className="flex items-center justify-between">
                                        <span>Location</span>
                                        <div className="relative">
                                            <button className="ml-1"><span>▼</span></button>
                                            <div className="absolute right-0 mt-2 hidden group-hover:block bg-white text-black border border-gray-200 shadow-lg rounded-md z-50 w-40">
                                                <div onClick={() => handleSort("location", "asc")} className="px-4 py-2 hover:bg-blue-100 cursor-pointer">Sort A → Z</div>
                                                <div onClick={() => handleSort("location", "desc")} className="px-4 py-2 hover:bg-blue-100 cursor-pointer">Sort Z → A</div>
                                            </div>
                                        </div>
                                    </div>
                                </th>

                                <th className="px-4 py-3 text-left min-w-[200px]">Information</th>
                                <th className="px-4 py-3 text-left min-w-[150px]">Keywords</th>
                                <th className="px-4 py-3 text-left min-w-[150px]">Email</th>
                                <th className="px-4 py-3 text-left min-w-[150px]">Website</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {sortedData.length > 0 ? (
                                sortedData.map((item, index) => (
                                    <tr key={index} className="hover:bg-gray-50 transition divide-x divide-gray-200 text-gray-800 text-sm">
                                        <td className="px-4 py-3 break-words">{item.name || "N/A"}</td>
                                        <td className="px-4 py-3 whitespace-nowrap">{item.location || "N/A"}</td>
                                        <td className="px-4 py-3 text-left break-words">{item.info || "N/A"}</td>
                                        <td className="px-4 py-3 text-left break-words">
                                            {Array.isArray(item.keywords)
                                                ? item.keywords.join(", ")
                                                : (item.keywords || "N/A")}
                                        </td>
                                        <td className="px-4 py-3 break-words">
                                            {item.email && item.email !== "N/A" ? (
                                                <a href={`mailto:${item.email}`} className="text-blue-600 hover:underline break-all block">
                                                    {item.email}
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                        <td className="px-4 py-3 break-words">
                                            {item.website && item.website !== "N/A" ? (
                                                <a
                                                    href={item.website.startsWith("http") ? item.website : `https://${item.website}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="text-blue-600 hover:underline"
                                                >
                                                    {item.website}
                                                </a>
                                            ) : "N/A"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-6 text-gray-500 italic">No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );


};

export default Directory;



